import { instance as axios } from '../untils/http'
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { errorHandler } from '../untils/errorHandler';
import { ErrorInformation } from 'src/models/errorInformation';
import { OptionPersonalLedgerView, RptOptionPersonalLedgerView , UserList ,
         Grantnos , GrantOfferDetails , GrantSummaryView , RptEsopMasterOptionView ,
         RptEsopExerciseView , RptEsopEnterFairValueView , SaveFairValue , 
         RptEsopAmortization , SaveESOPAmortization } from 'src/models/reportModel';
import { VestingMaster } from 'src/models/acceptofferDetail';

//================|| OPTION PERSONAL LEDGER SLICE ||=================//
type esopPersonalLedgerState = {
    loading: boolean;
    error: ErrorInformation;
    userList: UserList[];
    optionPersonalLedgerView: OptionPersonalLedgerView;
    rptOptionPersonalLedgerView: RptOptionPersonalLedgerView;
    vestingMaster: VestingMaster;
    grantnos: Grantnos[];
    grantOfferDetails: GrantOfferDetails[];
    grantSummaryView: GrantSummaryView[];
    rptEsopMasterOptionView: RptEsopMasterOptionView[];
    rptEsopExerciseView: RptEsopExerciseView[];
    rptEsopEnterFairValueView: RptEsopEnterFairValueView[];
    SaveResponse: string;
    rptEsopAmortization: RptEsopAmortization;
    CostCenterString: string;
}

type GrantNoAndID = {
    grantNo: string,
    userID: string
}

type userNameanduserID = {
    searchUserID: string,
    searchName: string,
}

type userIDandPlanID = {
    userID: string,
    PlanID: number,
}

type fromtoStatusID = {
    fromStatusID: number,
    toStatusID: number,
}

type grantNoAndofferStatusList = {
    grantNo: string,
    offerStatusList: string,
}

type FromDateandTodate = {
    fromDate: string,
    toDate: string,
}

type grantNoListandemploymentStatusList = {
    grantNoList: string,
    employmentStatusList: string,
}

type exerciseParams = {
    reportDate: number,
    fromDate: string,
    toDate: string,
    showConfirmedExerciseOnly: boolean,
}

type AmortizeParams = {
    grantDateFrom: string,
    grantDateTo: string,
    schedulePeriodFrom: string,
    schedulePeriodTo: string,
    isUseActualForfeiture: boolean,
    forfeitureRate: number,
    isAdjustYearly: boolean,
}

type costcenterParams = {
    schedulePeriodFrom: string,
    schedulePeriodTo: string,
}

const initialState: esopPersonalLedgerState = {
    loading: false,
    error: null,
    userList: [],
    optionPersonalLedgerView: {
        options: [],
        fullName: '',
        nric: '',
    },
    rptOptionPersonalLedgerView: null,
    vestingMaster: null ,
    grantnos:[],
    grantOfferDetails:[],
    grantSummaryView:[],
    rptEsopMasterOptionView:[],
    rptEsopExerciseView:[],
    rptEsopEnterFairValueView:[],
    SaveResponse: '',
    rptEsopAmortization: null,
    CostCenterString: '',
};

export const getUserList = createAsyncThunk(
    "esopPersonalLedger/getUserList",
    async (userNameanduserID: userNameanduserID, { rejectWithValue }) => {
        try {
            if(userNameanduserID.searchUserID.toString() != '' && 
            userNameanduserID.searchName.toString() != '') {
                const getUserListOption = await axios.get<string>(`Profile/getSearchUser?searchUserID=${userNameanduserID.searchUserID.toString()}&searchName=${userNameanduserID.searchName.toString()}`)
                return getUserListOption.data
            }
            else if(userNameanduserID.searchUserID.toString() != '') {
                const getUserListOption = await axios.get<string>(`Profile/getSearchUser?searchUserID=${userNameanduserID.searchUserID.toString()}`)
                return getUserListOption.data
            }
            else if(userNameanduserID.searchName.toString() != '') {
                const getUserListOption = await axios.get<string>(`Profile/getSearchUser?searchName=${userNameanduserID.searchName.toString()}`)
                return getUserListOption.data
            }
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const getPersonalLedgerView = createAsyncThunk<OptionPersonalLedgerView, {}, { rejectValue: ErrorInformation }>(
    "esopPersonalLedger/getPersonalLedgerView",
    async (userID: string, { rejectWithValue }) => {
        try {
            const optionPersonalLedgerViewResponse = await axios.get<OptionPersonalLedgerView>(`ReportService/getPersonalLedgerView?userID=${userID}`);
            return optionPersonalLedgerViewResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const getPersonalLedger = createAsyncThunk(
    "esopPersonalLedger/getPersonalLedger",
    async (params: userIDandPlanID, { rejectWithValue }) => {
        try {
            const getPersonalLedgerResponse = await axios.get<RptOptionPersonalLedgerView>(`ReportService/getPersonalLedger?userID=${params.userID}&PlanID=${params.PlanID}`)
            return getPersonalLedgerResponse['data']
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const getVestingSchedule = createAsyncThunk(
    "esopPersonalLedger/getVestingSchedule",
    async (grantNoAndID: GrantNoAndID, { rejectWithValue }) => {
        try {
            const getVestingScheduleResponse = await axios.get<VestingMaster>(`ReportService/getOptionVestingSchedule?GrantNo=${grantNoAndID.grantNo}&GrantUserID=${grantNoAndID.userID}`)
            return getVestingScheduleResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

// Grant Offer 

export const getGrantNo = createAsyncThunk(
    "esopPersonalLedger/getGrantNo",
    async (fromtoStatusID: fromtoStatusID, { rejectWithValue }) => {
        try {
            const getGrantNoResponse = await axios.get<Grantnos>(`Grant/getGrantNo?fromStatusID=${fromtoStatusID.fromStatusID}&toStatusID=${fromtoStatusID.toStatusID}`)
            return getGrantNoResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const getGrantOfferReport = createAsyncThunk(
    "esopPersonalLedger/getGrantOfferReport",
    async (params: grantNoAndofferStatusList, { rejectWithValue }) => {
        try {
            const getGrantOfferReportResponse = await axios.get<GrantOfferDetails>(`ReportService/getGrantOfferReport?grantNo=${params.grantNo}&offerStatusList=${params.offerStatusList}`)
            return getGrantOfferReportResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

// Grant Summary

export const getGrantSummaryReport = createAsyncThunk(
    "esopPersonalLedger/getGrantSummaryReport",
    async (fromDateandTodate: FromDateandTodate, { rejectWithValue }) => {
        try {
            const getGrantSummaryReportResponse = await axios.get<GrantSummaryView>(`ReportService/getGrantSummaryReport?fromDate=${fromDateandTodate.fromDate}&toDate=${fromDateandTodate.toDate}`)
            return getGrantSummaryReportResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

// Master Option

export const getMasterOptionReport = createAsyncThunk(
    "esopPersonalLedger/getMasterOptionReport",
    async (params: grantNoListandemploymentStatusList, { rejectWithValue }) => {
        try {
            const getMasterOptionReportResponse = await axios.get<RptEsopMasterOptionView>(`ReportService/getMasterOptionReport?grantNoList=${params.grantNoList}&employmentStatusList=${params.employmentStatusList}`)
            return getMasterOptionReportResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

// Exercise Option

export const getExerciseReport = createAsyncThunk(
    "esopPersonalLedger/getExerciseReport",
    async (params: exerciseParams, { rejectWithValue }) => {
        try {
            const getExerciseReportResponse = await axios.get<RptEsopExerciseView>(`ReportService/getExerciseReport?reportDate=${params.reportDate}&fromDate=${params.fromDate}&toDate=${params.toDate}&showConfirmedExerciseOnly=${params.showConfirmedExerciseOnly}`)
            return getExerciseReportResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

// Enter Fair Value

export const getFairValue = createAsyncThunk(
    "esopPersonalLedger/getFairValue",
    async (fromDateandTodate: FromDateandTodate, { rejectWithValue }) => {
        try {
            const getFairValueResponse = await axios.get<RptEsopEnterFairValueView>(`ReportService/getFairValue?fromDate=${fromDateandTodate.fromDate}&toDate=${fromDateandTodate.toDate}`)
            return getFairValueResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const setFairValue = createAsyncThunk<number, { grantInfo: SaveFairValue }, { rejectValue: ErrorInformation }>(
    "esopPersonalLedger/setFairValue",
    async ({grantInfo}, { rejectWithValue }) => {
        try {
            const response = await axios.post('/ReportService/setFairValue', grantInfo)
            return response.data[0];
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

// Amortization Report

export const getAmortizeSchedule = createAsyncThunk(
    "esopPersonalLedger/getAmortizeSchedule",
    async (params: AmortizeParams, { rejectWithValue }) => {
        try {
            const getAmortizeScheduleResponse = await axios.get<RptEsopEnterFairValueView>(`ReportService/getAmortizeSchedule?grantDateFrom=${params.grantDateFrom}&grantDateTo=${params.grantDateTo}
                &schedulePeriodFrom=${params.schedulePeriodFrom}&schedulePeriodTo=${params.schedulePeriodTo}&isUseActualForfeiture=${params.isUseActualForfeiture}
                &forfeitureRate=${params.forfeitureRate}&isAdjustYearly=${params.isAdjustYearly}`)
            return getAmortizeScheduleResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const setAmortizeSchedule = createAsyncThunk<number, { Info: SaveESOPAmortization }, { rejectValue: ErrorInformation }>(
    "pspReports/setAmortizeSchedule",
    async ({Info}, { rejectWithValue }) => {
        try {
            const response = await axios.post('ReportService/setAmortizeSchedule', Info)
            return response.data[0];
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

// Cost Center Report

export const getCostCenterReport = createAsyncThunk(
    "esopPersonalLedger/getCostCenterReport",
    async (params: costcenterParams, { rejectWithValue }) => {
        try {
            const getCostCenterReportResponse = await axios.get<string>(`ReportService/getCostCenterReport?schedulePeriodFrom=${params.schedulePeriodFrom}
                &schedulePeriodTo=${params.schedulePeriodTo}`)
            return getCostCenterReportResponse['data']
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

const esopPersonalLedgerSlice = createSlice({
    name: 'esopPersonalLedger',
    initialState,
    reducers: {},
    extraReducers: {
        
        //get User List View
        [getUserList.pending.type]: (state) => {
            state.loading = true;
        },
        [getUserList.fulfilled.type]: (state, action) => {
            state.userList = action.payload;
            state.loading = false;
            state.error = null;
        },
        [getUserList.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        //get Option Personal Ledger View
        [getPersonalLedgerView.pending.type]: (state) => {
            state.loading = true;
        },
        [getPersonalLedgerView.fulfilled.type]: (state, action) => {
            state.optionPersonalLedgerView = action.payload;
            state.loading = false;
        },
        [getPersonalLedgerView.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },
        //get Vesting Schedule
        [getVestingSchedule.pending.type]: (state) => {
            state.loading = true;
        },
        [getVestingSchedule.fulfilled.type]: (state, action) => {
            state.vestingMaster = action.payload;
            state.loading = false;
        },
        [getVestingSchedule.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        //get Rpt Option Personal Ledger View
        [getPersonalLedger.pending.type]: (state) => {
            state.loading = true;
        },
        [getPersonalLedger.fulfilled.type]: (state, action) => {
            state.rptOptionPersonalLedgerView = action.payload;
            state.loading = false;
        },
        [getPersonalLedger.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        //Grant Offer
        //get Grant No
        [getGrantNo.pending.type]: (state) => {
            state.loading = true;
        },
        [getGrantNo.fulfilled.type]: (state, action) => {
            state.grantnos = action.payload;
            state.loading = false;
            state.error = null;
        },
        [getGrantNo.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        //get Grant Offer Details
        [getGrantOfferReport.pending.type]: (state) => {
            state.loading = true;
        },
        [getGrantOfferReport.fulfilled.type]: (state, action) => {
            state.grantOfferDetails = action.payload;
            state.loading = false;
            state.error = null;
        },
        [getGrantOfferReport.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        //Grant Summary
        //get Grant Summary Details
        [getGrantSummaryReport.pending.type]: (state) => {
            state.loading = true;
        },
        [getGrantSummaryReport.fulfilled.type]: (state, action) => {
            state.grantSummaryView = action.payload;
            state.loading = false;
            state.error = null;
        },
        [getGrantSummaryReport.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        //Master Option
        //get Master Option Details
        [getMasterOptionReport.pending.type]: (state) => {
            state.loading = true;
        },
        [getMasterOptionReport.fulfilled.type]: (state, action) => {
            state.rptEsopMasterOptionView = action.payload;
            state.loading = false;
            state.error = null;
        },
        [getMasterOptionReport.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        //Exercise Option
        //get Exercise Option Details
        [getExerciseReport.pending.type]: (state) => {
            state.loading = true;
        },
        [getExerciseReport.fulfilled.type]: (state, action) => {
            state.rptEsopExerciseView = action.payload;
            state.loading = false;
            state.error = null;
        },
        [getExerciseReport.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        //ESOP Expense
        //get Enter fair value
        [getFairValue.pending.type]: (state) => {
            state.loading = true;
        },
        [getFairValue.fulfilled.type]: (state, action) => {
            state.rptEsopEnterFairValueView = action.payload;
            state.loading = false;
        },
        [getFairValue.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        // Save Enter fair value
        [setFairValue.pending.type]: (state) => {
            state.loading = true;
        },
        [setFairValue.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.SaveResponse = action.payload
            state.loading = false;
            state.error = null;
        },
        [setFairValue.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        //get Amortization value
        [getAmortizeSchedule.pending.type]: (state) => {
            state.loading = true;
        },
        [getAmortizeSchedule.fulfilled.type]: (state, action) => {
            state.rptEsopAmortization = action.payload;
            state.loading = false;
        },
        [getAmortizeSchedule.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        // Save ESOP Amortization
        [setAmortizeSchedule.pending.type]: (state) => {
            state.loading = true;
        },
        [setAmortizeSchedule.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.SaveResponse = action.payload
            state.loading = false;
            state.error = null;
        },
        [setAmortizeSchedule.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        //get Cost Center
        [getCostCenterReport.pending.type]: (state) => {
            state.loading = true;
        },
        [getCostCenterReport.fulfilled.type]: (state, action) => {
            state.CostCenterString = action.payload;
            state.loading = false;
        },
        [getCostCenterReport.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },
    }
})
export default esopPersonalLedgerSlice